import React from 'react'
import { Box, Text, Tip } from "grommet"


const TTTip = props => {

    const TipContent = ({ hoverMessage }) => (
        <>
            {hoverMessage &&
                <Box direction="row" align="center" margin={{bottom: "xsmall"}}>
                    <Box background="black" direction="row" pad="xsmall">
                        <Text size="xsmall" color="white">{hoverMessage}</Text>
                    </Box>
                </Box>
            }
        </>
    );

    const dropDirection = !props.position ? { bottom: 'top' } : { top: 'bottom' }

    return (
        <Tip
            dropProps={{ align: dropDirection }}
            plain
            content={<TipContent hoverMessage={props.hoverMessage} />}>
                {props.children}
        </Tip>
    )
}

export const TTTipMulti = props => {

    const TipContent = ({ hoverMessage }) => (
        <>
            {hoverMessage &&
                <Box direction="row" align="center" margin={{bottom: "xsmall"}}>
                    <Box background="black" direction="column" pad="xsmall" wrap>
                        {hoverMessage.map(line => {
                            return(<Text key={line} size="small" color="white">{line}</Text>)
                        })}
                    </Box>
                </Box>
            }
        </>
    );

    const dropDirection = !props.position ? { bottom: 'top' } : { top: 'bottom' }

    return (
        <Tip
            dropProps={{ align: dropDirection }}
            plain
            content={<TipContent hoverMessage={props.hoverMessage} />}>
                {props.children}
        </Tip>
    )
}

export default TTTip
